/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { useForm } from 'react-hook-form';
import makeStyles from '@material-ui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { NumberField } from '../../../common/NumberField';
import { StyledTableCell } from './StyledTableCell';

const useStyles = makeStyles(() => ({
  hiddenLabel: {
    '& label': {
      border: '0',
      clip: 'rect(0 0 0 0)',
      height: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: '0',
      position: 'absolute',
      width: '1px',
    },
    '& legend > span': {
      display: 'none',
    },
  },
}));

export function FeeInputNumberCell({ value, fee, disabled, onChange, onBlur, ...props }) {
  const form = useForm({
    mode: 'onChange',
    criteriaMode: 'all',
  });
  const { errors, register } = form;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <StyledTableCell {...props}>
      <NumberField
        className={classes.hiddenLabel}
        value={value}
        label={t('fees.quantity')}
        name={`quantityInput-${fee.code}`}
        onChange={onChange}
        onBlur={onBlur}
        errors={errors}
        helperText={errors[`quantityInput-${fee.code}`]?.message}
        register={register}
        disabled={disabled}
        type="number"
        maxValue={999999}
      />
    </StyledTableCell>
  );
}
